export const center_app_version = {"commit_sha": "475a0901"}
